// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"018fedfd","200":"d343fa62","448":"b7115e69","867":"13989dc8","879":"e70dd503","896":"fd9a55d5"}[chunkId] + ".chunk.js";
};